import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AvlaRestClientService } from 'base-angular-avla';

import { BulkLoadType } from '../enums/bulk-load-type.enum';

@Injectable()
export class CargaArchivoService {
  baseUrl = '';
  // baseUrl = 'http://localhost:8086'; // Ford dev

  _headers: HttpHeaders;

  urlPresignUrlForUploadMassiveFileLines = `${this.baseUrl}/api-mark-list/presignUrlForUploadMassiveFileLines`;
  urlRequestMassiveFileLines = `${this.baseUrl}/api-mark-list/requestMassiveFileLines`;
  urlGetExecutionProcess = `${this.baseUrl}/api-mark-list/getExecutionProcess`;

  constructor(
    private readonly http: HttpClient,
    private readonly restclient: AvlaRestClientService
  ) {}

  public getPreSignUploadFile(format: string): Observable<string> {
    return this.restclient.getSingle(
      this.urlPresignUrlForUploadMassiveFileLines,
      [],
      { format },
      { responseType: 'text' }
    );
  }

  public loadDataFromfile(
    urlLoad: string,
    format: string,
    bulkLoadType: BulkLoadType
  ): Observable<number> {
    const urlfromload = {
      urlUploadedFile: urlLoad,
      format,
      bulkLoadType,
    };
    return this.restclient
      .post(this.urlRequestMassiveFileLines, [], null, urlfromload)
      .pipe(map(res => res));
  }

  public getProcessStatus(proccessID: number): Observable<any> {
    const urlExecutionProcess: string =
      this.urlGetExecutionProcess + '/' + proccessID;
    return this.restclient.getSingle(urlExecutionProcess, [], null).pipe(
      map(res => res),
      catchError(e => throwError(e))
    );
  }

  public loadFileToUrl(url: string, file: any): Observable<any> {
    return this.http.put(url, file, { headers: this._headers });
  }
}
